module.exports = __webpack_public_path__ + "media/images/classic_assignment-1ec65ab90a86112b32733c5330eb179a.svg";